import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { useFetch } from '../../services/transports';
import { isLocationUpdated, UpdateLocation } from '../../api/locationChecker';
import { useFormGenerator } from '../../formGenerator/useFormGenerator';
import { formFields } from '../../constants';
import { FIELD_TYPE } from '../../formGenerator/CONSTANT';
import { MapLatLong } from '../containers/StakeholderUsers/MapLatLong';

import style from './LocationChecker.module.scss';

const LocationCheckerComponent = ({ isTesting }) => {
  const [ { data }, fetchData ] = useFetch(isLocationUpdated,
    (response => response?.data?.container));

  // eslint-disable-next-line no-unused-vars
  const [ { isSuccess }, submit ] = useFetch(UpdateLocation,
    (() => {
      fetchData();
    }));

  useEffect(() => {
    fetchData();
  }, []);

  const [ t ] = useTranslation();

  const { formik } = useFormGenerator({
    schema: [
      {
        id: formFields.LATITUDE,
        fieldType: FIELD_TYPE.STRING
      },
      {
        id: `${formFields.LATITUDE}_Required`,
        hidden: true,
        initial: true
      },
      {
        id: formFields.LONGITUDE,
        fieldType: FIELD_TYPE.STRING
      },
      {
        id: `${formFields.LONGITUDE}_Required`,
        hidden: true,
        initial: true
      }
    ],
    onSubmit: values => {
      submit({
        longitude: values[formFields.LONGITUDE],
        latitude: values[formFields.LATITUDE]
      });
    }
  });

  return (
    <Modal
      visible={ data === false }
      closable={ false }
      footer={ null }
      title={ t('warnings.pleaseUpdateYourLocationInformation') }
    >
      <MapLatLong formik={ formik } isTesting={ isTesting } />
      <div className={ style.buttonContainer }>
        <Button type="submit" onClick={ formik.handleSubmit }>{t('btns.save')}</Button>
      </div>
    </Modal>
  );

};

export const LocationChecker = ({ portal, username, isTesting = false }) => {
  if (portal !== 'sop' || !username?.endsWith('0')) {
    return null;
  }

  return <LocationCheckerComponent isTesting={ isTesting } />;
};
